import { Component, OnInit, Input } from '@angular/core';
import { SubmissionsService } from '../_services/submissions.service';
import { SubmissionSteps, AddressType, ClearAccountIndicators } from 'src/app/_common/_enum/module.enum';
import { Submission, SubmissionMethod } from '../_models/submission';
import { SUBMISSION_MSGS } from 'src/app/_common/product-config';

@Component({
  selector: 'app-submission-review',
  templateUrl: './submission-review.component.html',
  styleUrls: ['./submission-review.component.scss']
})
export class SubmissionReviewComponent implements OnInit {

  private submissionReview: Submission;
  private submissionData;
  private referenceData;
  
  private submissionSteps = SubmissionSteps;
  private clearAccountIndicators = ClearAccountIndicators;
  private submissionMsgs = SUBMISSION_MSGS;
  private submissionMethod: SubmissionMethod = new SubmissionMethod();

  private businessAddress;
  private mailingAddress;
  private billingAddress;

  private uploadedDocuments;

  @Input() isNewSubmission: boolean = true;

  constructor(private submissionService: SubmissionsService) { }

  ngOnInit() {
    this.referenceData = this.submissionService.referenceData;
    this.submissionReview = this.getSubmission();
    this.submissionData = this.submissionReview.submissionData;

    this.retrieveSubmissionAddresses();

    if(this.isNewSubmission){
      this.uploadedDocuments = this.submissionService.getSupportingDocuments();
    }else{
      this.uploadedDocuments = this.submissionData.attachments;
    }
  }
  
  getSubmission(){
    return this.submissionService.submission;
  }

  retrieveSubmissionAddresses(){
    this.businessAddress = this.submissionMethod.getBusinessAddress(this.submissionReview);
    if(!this.isNewSubmission){
      this.submissionReview.isMailingSameAsInsured = (this.submissionData.isMailingOrBillingSameAsInsured <= 1);
      this.submissionReview.isBillingSameAsMailing = (this.submissionData.isMailingOrBillingSameAsInsured == 0 || this.submissionData.isMailingOrBillingSameAsInsured == 2);
    }

    this.mailingAddress = this.submissionMethod.getMailingAddress(this.submissionReview);
    this.billingAddress = this.submissionMethod.getBillingAddress(this.submissionReview);

    if(!this.mailingAddress){
      this.mailingAddress = this.businessAddress;
    }
    if(!this.billingAddress){
      this.billingAddress = this.mailingAddress;
    }
  }

  /* getFeinNumber(_feinNumber){
    if(_feinNumber){
     if(_feinNumber.indexOf("-") > -1){
       return _feinNumber;
     }else{
       return _feinNumber.substr(0,2) + '-' + _feinNumber.substr(2, _feinNumber.length);
     }
    }else{
      return "";
    }
  } */

  getRiskStateDisplayName(_stateAbb){
    let state = this.referenceData.states.find(_state => {return _state.abbreviation == _stateAbb});
    if(state){
      return state.stateName;
    }else{
      return _stateAbb;
    }
  }

  getPhoneNumber(_phone){
    if(_phone){
      if(_phone.indexOf("(")>-1 && _phone.indexOf(")") > -1){
        return _phone;
      }else{
        var cleaned = ('' + _phone).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
          return '(' + match[1] + ')' + match[2] + '-' + match[3];
        }else{
          return "";
        }
      }
    }
    return "";
  }

  editRequest(_submissionStep){
    if(_submissionStep == ''){
      _submissionStep = this.submissionSteps.BasicInfo;
    }

    this.submissionReview.selectedStep = _submissionStep;
    this.submissionService.selectedStep = _submissionStep;

    this.submissionService.submission = this.submissionReview;

    window.scrollTo(0, 0);
  }

}
